import { useAuth0 } from '@auth0/auth0-react'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

import { CenteredLoading } from '@/components/app/centered-loading'

// v1 (routes/_noMember/sign_out.tsx) と同じ意味論。ログアウト後は /sign_in へ直接戻す
// （origin へ戻すと '/' の AuthenticatedApolloProvider 経由で /sign_in へ二段リダイレクトになり、
// ローディングが一瞬挟まるため v1 と同じく直接指定にする）
function Page() {
  const { logout } = useAuth0()
  useEffect(() => {
    const f = async () => {
      await logout({
        logoutParams: {
          returnTo: `${window.location.origin}/sign_in`,
        },
      })
    }
    void f()
  }, [])

  return <CenteredLoading message="ログアウトしています..." />
}

export const Route = createFileRoute('/sign_out')({
  component: Page,
})
